module.exports = __webpack_public_path__ + "static/media/about.091983e0.jpg";